import React from "react";
import "./table.css";

export interface TableColumn<T> {
  key: string;
  header: string;
  render: (item: T, index: number) => React.ReactNode;
}

interface DataTableProps<T> {
  columns: TableColumn<T>[];
  data: T[];
  loading?: boolean;
  emptyMessage?: string;
  emptyDescription?: string;
  rowKey?: (item: T, index: number) => string | number;
}

export function DataTable<T>({
  columns,
  data,
  loading = false,
  emptyMessage = "No data available",
  emptyDescription = "There are no items to display at the moment",
  rowKey,
}: DataTableProps<T>) {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>
        Loading…
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="table-card empty-state">
        <h6>{emptyMessage}</h6>
        <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 24 }}>
          {emptyDescription}
        </p>
      </div>
    );
  }

  return (
    <div className="table-card">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={rowKey ? rowKey(item, index) : index}>
              {columns.map((column) => (
                <td key={column.key}>{column.render(item, index)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
